import styled, { css } from 'styled-components';

import { Card } from "../Card";
import { Subscription } from "../Subscription";

export const StyledSubscription = /*#__PURE__*/styled(Subscription).withConfig({ displayName: "styled__StyledSubscription", componentId: "sc-1072rxj-0" })(["position:relative;z-index:1;", ""],



(props) => css(["margin-bottom:", ";"],
props.theme.spacers.M));



export const NextCard = /*#__PURE__*/styled(Card).withConfig({ displayName: "styled__NextCard", componentId: "sc-1072rxj-1" })(["position:absolute;pointer-events:none;left:0;right:0;bottom:0;z-index:0;transition:all 0.2s;", ""],








(props) => css(["top:", ";"],
props.theme.spacers.M));



export const Main = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__Main", componentId: "sc-1072rxj-2" })(["display:flex;flex-direction:column;position:relative;width:100%;", ""],





(props) => css(["&:hover{", "{left:", ";right:", ";}}"],

NextCard,
props.theme.spacers.M,
props.theme.spacers.M));





export const QuantityIndicator = /*#__PURE__*/styled.div.withConfig({ displayName: "styled__QuantityIndicator", componentId: "sc-1072rxj-3" })(["", ";height:32px;width:32px;border-radius:16px;background-color:", ";position:absolute;top:0;right:0;display:flex;justify-content:center;align-items:center;color:", ";"],
(props) => css(props.theme.typography.SmallHeadline),



({ theme, $color }) => $color !== null && $color !== void 0 ? $color : theme.colors.secondary,






(props) => props.theme.colors.Background);